<template>
  <div class="row">
    <div class="col-md-12">

      <div class="text-center" v-if="userRoles === null"><md-progress-spinner md-mode="indeterminate"></md-progress-spinner></div>

      <fieldset v-else :disabled="pageType === 'view'">
        <div class="widget fluid">
          <div class="whead">
            <h6>Basic Info</h6>
          </div>
          <div class="card-body card-block">
            <form
              action
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              v-on:submit.prevent="save()"
            >
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="email" class v-required>Email</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="email"
                    name="email"
                    placeholder
                    class="form-control"
                    v-model="input.email"
                    @keyup="checkEmailExists()"
                    @blur="checkEmailExists()"
                    ref="email"
                  >
                  <small class="text-danger" v-if="emailExists">Email already exists</small>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="password" class="form-control-label" v-required>Password</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="password"
                    id="password"
                    name="password"
                    placeholder
                    v-model="input.password"
                    class="form-control"
                    ref="password"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="name" class="form-control-label" v-required>Name</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder
                    class="form-control"
                    v-model="input.name"
                    ref="name"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="short_name" class="form-control-label" v-required>Short Name</label>
                </div>
                <div class="col-12 col-md-9">
                  <input
                    type="text"
                    id="short_name"
                    name="short_name"
                    placeholder
                    class="form-control"
                    v-model="input.short_name"
                    ref="short_name"
                  >
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="roles" class="form-control-label" v-required>Role</label>
                </div>
                <div class="col-12 col-md-9">
                  <select
                    id="roles"
                    name="roles"
                    placeholder
                    class="form-control"
                    ref="roles"
                    v-model="input.roles.name"
                  >
                    <option
                      v-for="userRole in userRoles"
                      :value="userRole.name"
                      :key="userRole.name"
                    >{{userRole.name}}</option>
                  </select>
                </div>
              </div>
              <div class="row form-group">
                <div class="col col-md-3">
                  <label for="name" class="form-control-label">Status</label>
                </div>
                <div class="col-12 col-md-9">
                  <md-switch
                    v-model="input.active"
                    value="1"
                    class="md-primary"
                    :disabled="pageType === 'view'"
                  ></md-switch>
                </div>
              </div>
            </form>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>

import save from 'src/global/save.js'
import back from 'src/global/back.js'
import getData from 'src/global/getData.js'
import createItem from 'src/global/createItem.js'
import updateItem from 'src/global/updateItem.js'
import validation from 'src/global/validation.js'

import UserModel from './model/User'

export default {
  data() {
    return {
      pageSettings: {
        pageTitle: 'User',
        sectionName: 'user',
        sectionIcon: 'fas fa-users',
        type: this.pageType,
        useDefault: true,
        webService: this.$root.WebService.user,
        modelID: this.$route.params.id ? this.$route.params.id : null,
        navigation: [
          { name: 'User', route: 'user.index' },
          { name: this.$options.filters.capitalize(this.pageType) },
        ],
        buttons: [
          (this.pageType !== 'view' ? { name: 'Save', icon: 'fas fa-save', action: this.save } : null),
          { name: 'Back', icon: 'fas fa-arrow-left', action: this.back },
        ],
        subSidebar: {
          buttons: [
            { name: 'User List', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'user.index' }) } },
            { name: 'Roles & Permission', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'user.rolePermission.index' }) } },
          ]
        }
      },
      input: UserModel(),
      requiredInput: [
        {key: 'email', title: 'Email'},
        {key: 'name', title: 'Name'},
        {key: 'short_name', title: 'Short Name'},
      ],
      userRoles: null,
      modelID: this.$route.params.id ? this.$route.params.id : null,
      emailExists: false,
      processing: false,
    }
  },
  props: {
    pageType: String
  },
  created() {
    this.getUserRole()
    this.getData()
  },
  mounted() {
    this.$emit('setPageHeader', this.pageSettings)
  },
  methods: {
    afterGetData() {
      this.input.active = this.input.active.toString()
      let roles = this.input.roles
      this.input.roles = {
        id: roles.id,
        name: roles.name
      }
    },
    getUserRole() {
      this.$http
        .get(this.WebService.role)
        .then((response) => {

          if( this.modelID == 1 )
            this.userRoles = response.data.data
          else
            this.userRoles = (response.data.data).slice(1)

        })
        .catch((err) => {

        })
        .finally(null)
    },
    checkEmailExists() {

      if (this.input.email)

        this.$http
          .post(this.WebService.user + '/checkEmailExists', {
            email: this.input.email,
            id: this.modelID
          })
          .then((response) => {
            if (response.data > 0) {
              this.emailExists = true
            } else {
              this.emailExists = false
            }
          })
          .catch((err) => {

          })
          .finally()

    },
    extraValidation() {
      let errors = []

      if( !this.modelID && !this.input.password )
        errors.push('Password is required')

      if( !this.input.roles.name )
        errors.push('Role is required')

      if( this.input.email && !this.validEmail(this.input.email) )
        errors.push('Invalid email address')

      return errors
    },
    back,
    save,
    getData,
    createItem,
    updateItem,
    validation
  }
}
</script>